import type { GameSessionInternal } from '@repo/types/sessions/session-types';
import { createContext, type ReactNode, useContext, useMemo } from 'react';

interface SessionTrailsValue {
    showSessionTrail: (session: GameSessionInternal) => void;
    hideSessionTrail: () => void;
    getCurrentSession: () => GameSessionInternal | null;
    timelineVisible: boolean;
    setTimelineVisible: (visible: boolean) => void;
    currentSession: GameSessionInternal | null;
    setCurrentSession: (session: GameSessionInternal | null) => void;
}

type SessionHistoryContextValue = SessionTrailsValue;

const SessionHistoryContext = createContext<SessionHistoryContextValue | null>(null);

interface SessionHistoryProviderProps {
    children: ReactNode;
    sessionTrails: SessionTrailsValue;
}

export const SessionHistoryProvider: React.FC<SessionHistoryProviderProps> = ({ children, sessionTrails }) => {
    const value: SessionHistoryContextValue = useMemo(
        () => ({
            ...sessionTrails,
        }),
        [sessionTrails],
    );

    return <SessionHistoryContext.Provider value={value}>{children}</SessionHistoryContext.Provider>;
};

export const useSessionHistory = (): SessionHistoryContextValue => {
    const context = useContext(SessionHistoryContext);
    if (!context) {
        throw new Error('useSessionHistory must be used within SessionHistoryProvider');
    }
    return context;
};
